export default "__VITE_ASSET__BQ2IOYi5__"